<template>
  <layout title="Administration - Netexial" :loading="loading" :error="error" @tryLogin="login"></layout>
</template>

<script>
  import gql from 'graphql-tag';
  import {AppMixin} from '../mixins/app-mixin';
  import Layout from 'package-common-vuejs/src/layouts/LoginLayout';

  export default {
    mixins: [AppMixin],
    components: {
      Layout,
    },
    data() {
      return {
        error: null,
        loading: false,
        user: null,
      };
    },
    apollo: {
      user: {
        query: gql`query {
          user: userInfo { id name isAdmin permissions }
        }`,
        fetchPolicy: 'network-only',
        result({data: {user}}) {
          this.redirectAfterAuth(user);
        },
      },
    },
    created() {
      this.refresh();
    },
    methods: {
      /**
       * Redirection déclenchée après une authentification réussie.
       * Ne dépend pas du hook `result()` de la smart query `user`, qui peut ne pas
       * se redéclencher après un `refetch()` faisant suite à l'échec initial systématique
       * de la query (non authentifié au montage de /login).
       */
      redirectAfterAuth(user) {
        this.$store.dispatch('setUser', user);
        this.$router.push({path: this.$route.query.referer || '/'});
      },
      /**
       * Use the refresh token to re-auth the user
       */
      async refresh() {
        try {
          const refreshToken = localStorage.getItem('refresh_token');
          const expiresAt = Number(localStorage.getItem('expires_at'));
          if (refreshToken && expiresAt && expiresAt < new Date().getTime()) { // Force refresh token
            const {data: {tokenInfos}} = await this.$apollo.mutate({
              mutation: gql`mutation ($refreshToken: String!) {
                tokenInfos: userRefreshToken(refreshToken: $refreshToken) {
                  access_token
                  expires_in
                }
              }`,
              variables: {
                refreshToken
              },
            });
            localStorage.setItem('expires_at', (new Date()).getTime() + tokenInfos.expires_in * 1000);
            const {data: {user}} = await this.$apollo.queries.user.refetch();
            this.redirectAfterAuth(user);
          }
        } catch (err) {
        }
      },
      async login({username, password}) {
        if (!username) {
          this.error = 'Le nom d\'utilisateur est obligatoire !';
          return;
        }
        if (!password) {
          this.error = 'Le mot de passe est obligatoire !';
          return;
        }
        this.loading = true;
        this.error = null;
        try {
          const {data: {tokenInfos}} = await this.$apollo.mutate({
            mutation: gql`mutation ($username: String!, $password: String!) {
              tokenInfos: userLogin(username: $username, password: $password) {
                access_token
                expires_in
                refresh_token
              }
            }`,
            variables: {
              username,
              password,
            },
          });
          localStorage.setItem('refresh_token', tokenInfos.refresh_token);
          localStorage.setItem('expires_at', (new Date()).getTime() + tokenInfos.expires_in * 1000);
          const {data: {user}} = await this.$apollo.queries.user.refetch();
          this.redirectAfterAuth(user);
          this.loading = false;
        } catch(err) {
          this.loading = false;
          switch (true) {
            case err.message.includes('User not found!'):
              this.error = `L'utilisateur n'existe pas`;
              break;
            case err.message.includes('Wrong password!'):
              this.error = `Le mot de passe est incorrect`;
              break;
            default:
              this.error = err.message;
          }
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LayoutSignedOut.vue